var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tooltip',{attrs:{"placement":"topLeft","arrow-point-at-center":"","get-popup-container":_vm.getPopupContainer,"overlayStyle":{'max-width': '400px'}}},[(_vm.isTruncated)?_c('template',{slot:"title"},[_vm._v(" "+_vm._s(_vm.info)+" ")]):_vm._e(),_c('p',{ref:"info",staticClass:"info-text"},[_vm._v(_vm._s(_vm.info))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }